import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Flex, Link } from 'components/ui';
import { colors } from 'style/config';
import ProductImage from 'components/Product/ProductImage/ProductImage.f';
import anaUtils from 'analytics/utils';

const styles = {
    container: {
        marginTop: 12,
        direction: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 16
    },
    image: {
        display: 'inline-block',
        size: 32
    },
    title: {
        is: 'p',
        fontWeight: 'bold',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    description: {
        is: 'p',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    redemptionBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        flexShrink: 0
    }
};

const RedemptionInfoSection = ({
    skuImages, src, title, description, link, redemptionValue, accessibleRedemptionLabel
}) => {
    const imageProps = { size: 40, src, skuImages };

    const handleBrandLinkClick = () => {
        anaUtils.setNextPageData({
            linkData: 'points activity:shop this brand',
            prop55: 'points activity:shop this brand',
            pageName: digitalData?.page?.attributes?.sephoraPageInfo?.pageName
        });
    };

    return (
        <Flex css={styles.container}>
            <ProductImage {...imageProps} />
            <Flex
                flexDirection='column'
                alignItems='stretch'
                flex={1}
                minWidth={0}
                overflow='hidden'
            >
                {title && (
                    <Text
                        css={styles.title}
                        children={title}
                    />
                )}
                {description && (
                    <Text
                        css={styles.description}
                        children={description}
                    />
                )}
                {link && link.url && (
                    <Link
                        href={link.url}
                        color={colors.blue}
                        onClick={handleBrandLinkClick}
                        children={link.text}
                        role='link'
                    />
                )}
            </Flex>
            <Text
                aria-label={accessibleRedemptionLabel}
                css={styles.redemptionBox}
                role='text'
            >
                {redemptionValue}
            </Text>
        </Flex>
    );
};

export default wrapFunctionalComponent(RedemptionInfoSection, 'RedemptionInfoSection');
